/**
 * グローバルスコープ
 */
import $ from 'jquery'

// Window
export const $window = $(window);

// Body
export const $body = $('body');

// Global Header
export const $header = $('.js-header');